/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ShivaWebSecuredConfiguration, ShivaWebSecuredConfigurationParams } from './shiva-web-secured-configuration';

import { LoginService } from './services/login.service';
import { ReportingService } from './services/reporting.service';
import { TechnicalAccountsService } from './services/technical-accounts.service';
import { UsersService } from './services/users.service';
import { PersonalSpaceService } from './services/personal-space.service';
import { PersonalSpaceSubscriptionService } from './services/personal-space-subscription.service';
import { MapService } from './services/map.service';
import { TagService } from './services/tag.service';
import { TagComputedService } from './services/tag-computed.service';
import { MapSubscriptionService } from './services/map-subscription.service';
import { SitesManagementService } from './services/sites-management.service';
import { SitesOperationService } from './services/sites-operation.service';
import { GraphsService } from './services/graphs.service';
import { SitesSynopticsService } from './services/sites-synoptics.service';
import { OpcuaConnectionService } from './services/opcua-connection.service';
import { SmsConnectionService } from './services/sms-connection.service';
import { OcppConnectionService } from './services/ocpp-connection.service';
import { ChargingService } from './services/charging.service';
import { SitesExcelImportExportService } from './services/sites-excel-import-export.service';
import { EnedisConnectionService } from './services/enedis-connection.service';
import { GrdfConnectionService } from './services/grdf-connection.service';
import { HistoricalDataService } from './services/historical-data.service';
import { ForecastService } from './services/forecast.service';
import { SitesAlarmesService } from './services/sites-alarmes.service';
import { RealTimeDataService } from './services/real-time-data.service';
import { TicketingService } from './services/ticketing.service';
import { AcquisitionService } from './services/acquisition.service';
import { SubscriptionsService } from './services/subscriptions.service';
import { AuthorizationSupportsService } from './services/authorization-supports.service';
import { TransactionsService } from './services/transactions.service';
import { VehiclesService } from './services/vehicles.service';
import { SubServicesService } from './services/sub-services.service';
import { PartnersOperatorService } from './services/partners-operator.service';
import { AdministrationAgentService } from './services/administration-agent.service';
import { AdministrationRoleService } from './services/administration-role.service';
import { DiffusionListService } from './services/diffusion-list.service';
import { NetworksService } from './services/networks.service';
import { InformationMessagesService } from './services/information-messages.service';
import { CallNotificationService } from './services/call-notification.service';
import { TagGroupTypeService } from './services/tag-group-type.service';
import { ExternalApIsMonitoringService } from './services/external-ap-is-monitoring.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    LoginService,
    ReportingService,
    TechnicalAccountsService,
    UsersService,
    PersonalSpaceService,
    PersonalSpaceSubscriptionService,
    MapService,
    TagService,
    TagComputedService,
    MapSubscriptionService,
    SitesManagementService,
    SitesOperationService,
    GraphsService,
    SitesSynopticsService,
    OpcuaConnectionService,
    SmsConnectionService,
    OcppConnectionService,
    ChargingService,
    SitesExcelImportExportService,
    EnedisConnectionService,
    GrdfConnectionService,
    HistoricalDataService,
    ForecastService,
    SitesAlarmesService,
    RealTimeDataService,
    TicketingService,
    AcquisitionService,
    SubscriptionsService,
    AuthorizationSupportsService,
    TransactionsService,
    VehiclesService,
    SubServicesService,
    PartnersOperatorService,
    AdministrationAgentService,
    AdministrationRoleService,
    DiffusionListService,
    NetworksService,
    InformationMessagesService,
    CallNotificationService,
    TagGroupTypeService,
    ExternalApIsMonitoringService,
    ShivaWebSecuredConfiguration
  ],
})
export class ShivaWebSecuredModule {
  static forRoot(params: ShivaWebSecuredConfigurationParams): ModuleWithProviders<ShivaWebSecuredModule> {
    return {
      ngModule: ShivaWebSecuredModule,
      providers: [
        {
          provide: ShivaWebSecuredConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ShivaWebSecuredModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ShivaWebSecuredModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
